
import { defineComponent } from "vue";
import mpPopover from "../../../../components/mp-popover/mp-popover.vue";

export default defineComponent({
  components: { mpPopover },

  props: {
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    desc: {
      type: String
    },
    divider: {
      type: Boolean,
      default: true
    },
    buttonText: {
      type: String
    },
    buttonType: {
      type: String,
      default: 'default'
    },
    width: {
      type: Number,
      default: 20.36
    },
    align: {
      type: String,
      default: 'left'
    },
    white: {
      type: Boolean,
      default: false
    }
  }
})
